module.exports = __webpack_public_path__ + "static/media/FiveUmbrella.9cef7b41.png";